import { FiscalEvent, FiscalEventStatus } from '../../types/fiscal/FiscalEvent';

const order: FiscalEventStatus[] = ['DRAFT', 'VALIDATED', 'SIGNED', 'SENDING', 'PROCESSED'];
export default function FiscalEventTimeline({ event }: { event: FiscalEvent }) {
  const current = order.indexOf(event.status);
  return <ol className="grid grid-cols-5 gap-2 text-center text-xs">
    {order.map((status, index) => <li key={status} className={index <= current ? 'text-primary' : 'text-gray-400'}>
      <div className={`mx-auto mb-1 h-2 w-full rounded ${index <= current ? 'bg-primary' : 'bg-gray-200'}`} />
      {status}
    </li>)}
  </ol>;
}
